import { createAjaxEpic } from '../utils'
import { fetch, post, changeEmail, changePassword } from './actions'
import { fetchAccountAPI } from 'server/api/Account/api'
import { debug } from '../../../utils'
const log = debug('lego:Account/epics')

const fetchAccountEpic = createAjaxEpic(fetchAccountAPI);
const postAccountEpic = createAjaxEpic('/api/account/', post, 'post');

const changeEmailComplete = changeEmail.complete;
changeEmail.complete = [(payload, initialPayload) => changeEmailComplete({
 email: initialPayload.new_email
})] as any

const changeEmailEpic = createAjaxEpic('/api/account/email/', changeEmail, 'post')
const changePasswordEpic = createAjaxEpic('/api/account/password/', changePassword, 'post')

export {
	fetchAccountEpic,
	postAccountEpic,
	changeEmailEpic,
	changePasswordEpic,
};



// WEBPACK FOOTER //
// ./src/app/models/Account/epics.ts